import { CombinedProductBase, Product } from "./Product";
import getCombinedProductsAndProducts from "../util/get-combined-products-and-products";
import { getProductDetails } from "../util/get-product-details";
import setStoreCurrencyType from "../util/set-currency-type";

export const basicProductMapper = (product: Product) =>
  getProductDetails(product);

// TODO remove any's
export default function productsTransformer(
  response: any,
  meta: any,
  arg: any
) {
  const { combinedProducts, nonCombinedProducts, combinedProductIds } =
    getCombinedProductsAndProducts(response);

  const productMapper = (product: any) => ({
    ...product.contentObject,
    sortOrder: product.sortOrder,
  });

  const transformedCombinedProducts = combinedProducts
    .map(productMapper)
    .map((combinedProduct) => ({
      ...combinedProduct,
      products: combinedProduct?.products?.map(basicProductMapper),
    }));

  const transformedNonCombinedProducts = nonCombinedProducts
    .map(productMapper)
    .filter((product: any) => !product?.products)
    .map(basicProductMapper);

  const products = [
    ...transformedCombinedProducts,
    ...transformedNonCombinedProducts,
  ];

  setStoreCurrencyType(
    // get first product of first combine or first product
    products?.[0]?.products?.[0]?.currencyType ?? products?.[0]?.currencyType
  );

  return {
    products,
    combinedProducts:
      transformedCombinedProducts as unknown as CombinedProductBase,
    nonCombinedProducts: transformedNonCombinedProducts,
    combinedProductIds: Array.from(combinedProductIds),
  };
}
